/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { HistoryAlbumUser } from "./HistoryAlbumUser";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumBroadcastViewRecord {
  streamer: HistoryAlbumUser | undefined;
  totalViewHour: number;
}

function createBaseHistoryAlbumBroadcastViewRecord(): HistoryAlbumBroadcastViewRecord {
  return { streamer: undefined, totalViewHour: 0 };
}

export const HistoryAlbumBroadcastViewRecord = {
  encode(message: HistoryAlbumBroadcastViewRecord, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamer !== undefined) {
      HistoryAlbumUser.encode(message.streamer, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalViewHour !== 0) {
      writer.uint32(16).int64(message.totalViewHour);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumBroadcastViewRecord {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumBroadcastViewRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.streamer = HistoryAlbumUser.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalViewHour = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumBroadcastViewRecord {
    return {
      streamer: isSet(object.streamer) ? HistoryAlbumUser.fromJSON(object.streamer) : undefined,
      totalViewHour: isSet(object.totalViewHour) ? globalThis.Number(object.totalViewHour) : 0,
    };
  },

  toJSON(message: HistoryAlbumBroadcastViewRecord): unknown {
    const obj: any = {};
    if (message.streamer !== undefined) {
      obj.streamer = HistoryAlbumUser.toJSON(message.streamer);
    }
    if (message.totalViewHour !== 0) {
      obj.totalViewHour = Math.round(message.totalViewHour);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumBroadcastViewRecord>, I>>(base?: I): HistoryAlbumBroadcastViewRecord {
    return HistoryAlbumBroadcastViewRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumBroadcastViewRecord>, I>>(
    object: I,
  ): HistoryAlbumBroadcastViewRecord {
    const message = createBaseHistoryAlbumBroadcastViewRecord();
    message.streamer = (object.streamer !== undefined && object.streamer !== null)
      ? HistoryAlbumUser.fromPartial(object.streamer)
      : undefined;
    message.totalViewHour = object.totalViewHour ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
